import { Section, SectionHeading } from "@/components";
import { CardFaqCTA, CardFaqCTAType } from "@/components/ui/CardFaqCTA";
import { ColorKeys } from "@theme/colors.ts";
import { TypographyKeys } from "@theme/typography.ts";
import { ReactNode } from "react";
import { RichText } from "@/sections";
import "./FaqSections.scss";

function isHtmlEmpty(value: string | ReactNode | undefined): boolean {
  if (!value) return true;
  if (typeof value !== "string") return false;
  const text = value
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/g, "")
    .trim();
  return text.length === 0;
}

export type IconInfoType = {
  id?: string;
  url?: string;
  data?: any;
  size?: {
    width: number;
    height: number;
  };
  position?: {
    x: number;
    y: number;
  };
};

export type FaqItem = {
  key?: string;
  type: CardFaqCTAType;
  title: string;
  description?: string;
  link?: string;
  isExternal?: boolean;
  icon?: IconInfoType;
};

type Props = {
  title?: string;
  description?: string | ReactNode;
  items: FaqItem[];
  colorTitle?: ColorKeys;
  fontSizeTitle?: TypographyKeys;
  handleOpenModal?: (item: FaqItem) => void;
};

export const FaqSections = ({
  title,
  description,
  items = [],
  colorTitle = "primary",
  fontSizeTitle = "4",
  handleOpenModal,
}: Props) => {
  return (
    <Section className="faq-sections">
      <SectionHeading
        title={title}
        color={colorTitle}
        fs={fontSizeTitle}
        description={
          !isHtmlEmpty(description) ? (
            <RichText description={description}></RichText>
          ) : undefined
        }
        className="faq-sections__title"
      />
      <ul
        role="list"
        aria-label={`Lista di ${title}`}
        className={`faq-sections__list`}
      >
        {items?.map((item, index) => (
          <li key={item.key ?? index}>
            <CardFaqCTA
              type={item.type}
              title={item.title}
              description={item.description}
              link={item.link ?? ""}
              isExternal={item.isExternal}
              openModal={
                item.type === CardFaqCTAType.FAQ
                  ? () => handleOpenModal?.(item)
                  : undefined
              }
              icon={item.icon}
            />
          </li>
        ))}
      </ul>
    </Section>
  );
};
